import isEqual from 'lodash/isEqual'
import contracts from '@/api/contracts'

export default () => ({
  namespaced: true,
  state: {
    list: [],
    listFilters: {},
    cards: {}
  },
  actions: {
    fetch (context, { filters = {}, cached = true }) {
      if (cached && context.state.list.length && isEqual(context.state.listFilters, filters)) {
        return Promise.resolve()
      }
      return contracts.fetchCardsList(filters)
        .then(data => context.commit('fetch', { data, filters }))
    },
    fetchCard (context, { slug, cached = true }) {
      if (cached && context.state.cards[slug]) {
        return Promise.resolve()
      }
      return contracts.fetchCard(slug)
        .then(data => context.commit('fetchCard', { data, slug }))
    }
  },
  mutations: {
    fetch (state, { data, filters }) {
      state.list = data
      state.listFilters = filters
    },
    fetchCard (state, { data, slug }) {
      state.cards = {
        ...state.cards,
        [slug]: data
      }
    }
  },
  getters: {
    getBySlug: ({ cards }) => (slug) => {
      return cards[slug]
    }
  }
})
